import { connect } from 'react-redux';
import { updateEmployeeContributions } from '../../actions';
import { DeductionsTablePresenter } from './employee-deductions-table.view';

export const DeductionsTable = connect(null, {
  updateContributions: updateEmployeeContributions,
})(DeductionsTablePresenter);
